var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Button, Input, Select } from "semantic-ui-react";
import { cleanUpRnaSeq } from "../kit/rna-fish/ProbeSetForm";
import FieldWithErrorDisplay from "../FieldWithErrorDisplay";
var AddVariantModal = /** @class */ (function (_super) {
    __extends(AddVariantModal, _super);
    function AddVariantModal(props) {
        var _this = _super.call(this, props) || this;
        _this.onNameChange = function (event, data) {
            var str = data.value;
            _this.setState({ name: str });
        };
        _this.onProbeSetSizeChange = function (event, data) {
            var str = data.value;
            _this.setState({ probeSetSize: str });
        };
        _this.onAccessionChange = function (event, data) {
            var acc = data.value;
            if (acc === "") {
                _this.setState({ accessionId: undefined });
                return;
            }
            _this.setState({ accessionId: acc });
        };
        _this.onTargetMrnaSeqChange = function (event, data) {
            var value = data.value;
            _this.setState({
                targetMrnaSeq: cleanUpRnaSeq(value),
            });
        };
        _this.submitVariant = function () {
            _this.props.postRequest("/admin/catalog/rna/organisms/id/" + encodeURIComponent(_this.props.orgId.toString()) + "/probe-set-families/id/" + encodeURIComponent(_this.props.psfId.toString()) + "/variants", {
                name: _this.state.name,
                probeSetSize: _this.state.probeSetSize,
                accessionId: _this.state.accessionId,
                targetMrnaSeq: _this.state.targetMrnaSeq
            });
        };
        _this.state = {
            name: '',
            probeSetSize: '',
            accessionId: undefined,
            targetMrnaSeq: ''
        };
        return _this;
    }
    AddVariantModal.prototype.render = function () {
        return React.createElement(React.Fragment, null,
            React.createElement(FieldWithErrorDisplay, { errorPath: '/name', errors: this.props.state.errors, required: true, labelContent: 'Variant name' },
                React.createElement(Input, { onChange: this.onNameChange, placeholder: '1a', value: this.state.name })),
            React.createElement(FieldWithErrorDisplay, { errorPath: '/probeSetSizeLookup', errors: this.props.state.errors, required: true, labelContent: 'Probe size' },
                React.createElement(Input, { type: 'number', onChange: this.onProbeSetSizeChange, placeholder: '20', value: this.state.probeSetSize })),
            React.createElement(FieldWithErrorDisplay, { errorPath: '/accession', errors: this.props.state.errors, required: true, labelContent: 'Accession' },
                React.createElement(Select, { options: this.props.accessions.map(function (a) {
                        return {
                            text: a.transcriptAccession,
                            value: a.id
                        };
                    }), onChange: this.onAccessionChange, value: this.state.accessionId, clearable: true })),
            React.createElement(FieldWithErrorDisplay, { errorPath: '/targetMrnaSeq', errors: this.props.state.errors, required: true, labelContent: 'targetMrnaSeq' },
                React.createElement(Input, { onChange: this.onTargetMrnaSeqChange, placeholder: 'ACgU', value: this.state.targetMrnaSeq })),
            React.createElement(Button, { disabled: this.props.state.loading || this.props.state.success, icon: 'plus', label: 'Add variant', labelPosition: 'left', onClick: this.submitVariant, positive: true }));
    };
    return AddVariantModal;
}(React.PureComponent));
export default AddVariantModal;
//# sourceMappingURL=AddVariantModal.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/admin/AddVariantModal.js
// module id = 1456
// module chunks = 0